define('formkit/view/form/section/section.composite.view',['require','exports','module','marionette','uikit/uikit','./section.item.view','../../../templates','../../../form.object.util'],function(require, exports, module){
  var Mn                                         = require('marionette');
  var UIKit                                      = require('uikit/uikit');
  var SectionItemView                            = require('./section.item.view');
  var Templates                                  = require('../../../templates');
  var FormObjectUtil                             = require('../../../form.object.util');

  var SectionCompositeView = UIKit.CompositeView.extend({

    className: 'form-sections',

    template: Templates.App['section.composite'],

    childView: SectionItemView,
    childViewContainer: '.sections',
    childViewEventPrefix: 'section',

    childViewOptions: function() {
      return {
        form: this.form,
        enableActions: this.getOption('designable'),
        designable: this.getOption('designable')
      };
    },

    internalViewOptions: {
      sectionTitleView: {
        type: UIKit.Header,
        className: UIKit.Header.prototype.className + ' floated left',
        text: 'Sections',
        tagName: 'h4'
      },
      addSectionButton: function() {
        return {
          type: UIKit.Button,
          circular: true,
          color: 'white',
          compact: true,
          floated: 'right',
          icon: 'plus',
          visible: this.getOption('designable')
        }
      }
    },

    options: {
      designable: false
    },

    forceUpdate: {},

    onChangeDesignable: function(self, designable) {
      this.addSectionButton.visible = designable;

      this.children.each(function(cv) {
        cv.enableActions = designable;
      });

      if (designable) {
        this.triggerMethod('enable:drag');
      } else {
        this.triggerMethod('disable:drag');
      }
    }

  });

  module.exports = SectionCompositeView;
});

